var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnecting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_main1",
    attributeName: "transform",
    attributeType: "XML",
    from: "0 12 12",
    to: "365 12 12",
    begin: "0s; hinava_random_uuid_main2.end",
    dur: "8s",
    type: "rotate"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_main2",
    attributeName: "transform",
    attributeType: "XML",
    from: "365 12 12",
    to: "0 12 12",
    begin: "hinava_random_uuid_main1.end",
    dur: "8s",
    type: "rotate"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270, 12, 12)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 12,
    x2: 21,
    y2: 12,
    stroke: "#222",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_a1",
    attributeName: "transform",
    attributeType: "XML",
    from: "270 12 12",
    to: "315 12 12",
    begin: "0s; hinava_random_uuid_a2.end",
    dur: "1s",
    type: "rotate"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_a2",
    attributeName: "transform",
    attributeType: "XML",
    from: "315 12 12",
    to: "270 12 12",
    begin: "hinava_random_uuid_a1.end",
    dur: "1s",
    type: "rotate"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(225, 12, 12)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 12,
    x2: 21,
    y2: 12,
    stroke: "#222",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_b1",
    attributeName: "transform",
    attributeType: "XML",
    from: "225 12 12",
    to: "270 12 12",
    begin: "0.25s; hinava_random_uuid_b2.end",
    dur: "1s",
    type: "rotate"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_b2",
    attributeName: "transform",
    attributeType: "XML",
    from: "270 12 12",
    to: "225 12 12",
    begin: "hinava_random_uuid_b1.end",
    dur: "1s",
    type: "rotate"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180, 12, 12)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 12,
    x2: 21,
    y2: 12,
    stroke: "#222",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_c1",
    attributeName: "transform",
    attributeType: "XML",
    from: "180 12 12",
    to: "225 12 12",
    begin: "0.5s; hinava_random_uuid_c2.end",
    dur: "1s",
    type: "rotate"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_c2",
    attributeName: "transform",
    attributeType: "XML",
    from: "225 12 12",
    to: "180 12 12",
    begin: "hinava_random_uuid_c1.end",
    dur: "1s",
    type: "rotate"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(135, 12, 12)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 12,
    x2: 21,
    y2: 12,
    stroke: "#222",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_d1",
    attributeName: "transform",
    attributeType: "XML",
    from: "135 12 12",
    to: "180 12 12",
    begin: "0.75s; hinava_random_uuid_d2.end",
    dur: "1s",
    type: "rotate"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_d2",
    attributeName: "transform",
    attributeType: "XML",
    from: "180 12 12",
    to: "135 12 12",
    begin: "hinava_random_uuid_d1.end",
    dur: "1s",
    type: "rotate"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90, 12, 12)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 12,
    x2: 21,
    y2: 12,
    stroke: "#222",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_e1",
    attributeName: "transform",
    attributeType: "XML",
    from: "90 12 12",
    to: "135 12 12",
    begin: "1s; hinava_random_uuid_e2.end",
    dur: "1s",
    type: "rotate"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_e2",
    attributeName: "transform",
    attributeType: "XML",
    from: "135 12 12",
    to: "90 12 12",
    begin: "hinava_random_uuid_e1.end",
    dur: "1s",
    type: "rotate"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45, 12, 12)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 12,
    x2: 21,
    y2: 12,
    stroke: "#222",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_f1",
    attributeName: "transform",
    attributeType: "XML",
    from: "45 12 12",
    to: "90 12 12",
    begin: "1.25s; hinava_random_uuid_f2.end",
    dur: "1s",
    type: "rotate"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_f2",
    attributeName: "transform",
    attributeType: "XML",
    from: "90 12 12",
    to: "45 12 12",
    begin: "hinava_random_uuid_f1.end",
    dur: "1s",
    type: "rotate"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 12,
    x2: 21,
    y2: 12,
    stroke: "#222",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_g1",
    attributeName: "transform",
    attributeType: "XML",
    from: "0 12 12",
    to: "45 12 12",
    begin: "1.5s; hinava_random_uuid_g2.end",
    dur: "1s",
    type: "rotate"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_g2",
    attributeName: "transform",
    attributeType: "XML",
    from: "45 12 12",
    to: "0 12 12",
    begin: "hinava_random_uuid_g1.end",
    dur: "1s",
    type: "rotate"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnecting);
export default __webpack_public_path__ + "static/media/connecting.7b88313f05757dc1a71ecb7d5d468b27.svg";
export { ForwardRef as ReactComponent };